export const serviceID = "service_xbgtrx7";
export const templateID = "template_nns9d5a";
export const publicKey = "wippGiV77ZiolO4La";